import styles from "./MetaCard.module.css";
import GlobalIcon from "../GlobalIcon/GlobalIcon";
import Chart from "../Chart/Chart";

function MetaCard({ metaData }) {
  if (!metaData) {
    return null;
  }

  const {
    iconName,
    primaryLabel,
    secondaryLabel,
    value,
    percentageChange,
    isPositive,
    graphData = [],
    color = "#FF6B35", // Default orange color
  } = metaData;

  // Format value with commas
  const formattedValue = value?.toLocaleString() || "0";

  return (
    <div className={styles["meta-card"]}>
      <div className={styles["meta-card-header"]}>
        <div className={styles["meta-card-left"]}>
          <div 
            className={styles["meta-card-icon"]}
            style={{ backgroundColor: color }}
          >
            {iconName && (
              <GlobalIcon
                iconName={iconName}
                style={{ color: "white" }}
              />
            )}
          </div>
          <div className={styles["meta-card-labels"]}>
            <div className={styles["meta-card-primary-label"]}>
              {primaryLabel}
            </div>
            <div className={styles["meta-card-secondary-label"]}>
              {secondaryLabel}
            </div>
          </div>
        </div>
        <div className={styles["meta-card-right"]}>
          <div className={styles["meta-card-value"]}>{formattedValue}</div>
          <div
            className={`${styles["meta-card-percentage"]} ${
              isPositive ? styles["positive"] : styles["negative"]
            }`}
          >
            {percentageChange !== undefined && (
              <>
                {isPositive ? "+" : ""}
                {percentageChange}% {isPositive ? "↑" : "↓"}
              </>
            )}
          </div>
        </div>
      </div>
      {graphData && graphData.length > 0 && (
        <div className={styles["meta-card-graph"]}>
          <Chart
            chartType="area"
            data={graphData}
            options={{
              width: "100%",
              height: 40,
              strokeColor: color,
              gradientId: `areaGradient-${iconName}-${color}`,
              areaChartMargin: { top: 0, right: 0, left: 0, bottom: 0 },
              gradientStops: [
                { offset: "0%", opacity: 0.4 },
                { offset: "50%", opacity: 0.15 },
                { offset: "100%", opacity: 0 },
              ],
              areaDataKey: "value",
              areaType: "monotone",
              areaStrokeWidth: 1,
              showAreaGradient: true,
              showAreaGrid: false,
              showAreaXAxis: false,
              showAreaYAxis: false,
              areaXAxisProps: { hide: true },
              areaYAxisProps: { hide: true },
              areaTooltipProps: { content: () => null },
            }}
          />
        </div>
      )}
    </div>
  );
}

export default MetaCard;

